import { render } from "./ReferEquipmentComponent.vue?vue&type=template&id=0a4f470c"
import script from "./ReferEquipmentComponent.vue?vue&type=script&lang=js"
export * from "./ReferEquipmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__